import { generateRequest } from '.';
import createAreaKey from '../../lib/utils/createAreaKey';
import getRegionByName from '../../lib/utils/getRegionByName';

export const Action = {
  Geo: {
    FetchLocalities: 'FetchLocalities',
    FetchLocalitiesCompleted: 'FetchLocalitiesCompleted',
    FetchLocalitiesFailed: 'FetchLocalitiesFailed',
    FetchMetros: 'FetchMetros',
    FetchMetrosCompleted: 'FetchMetrosCompleted',
    FetchMetrosFailed: 'FetchMetrosFailed',
    FetchCounties: 'FetchCounties',
    FetchCountiesCompleted: 'FetchCountiesCompleted',
    FetchCountiesFailed: 'FetchCountiesFailed',
    FetchRegionCompleted: 'FetchRegionCompleted',
    FetchSuggestions: 'FetchSuggestions',
    FetchSuggestionsCompleted: 'FetchSuggestionsCompleted',
    FetchSuggestionsFailed: 'FetchSuggestionsFailed',
  },
};

export function fetchCounties(regionCode, countryCode) {
  const areaKey = createAreaKey({ regionCode, countryCode });
  const meta = { key: areaKey };
  return generateRequest({
    endpoint: `/assets-v2/api/geo/regions/${regionCode}/${countryCode}/counties`,
    types: [
      Action.Geo.FetchCounties,
      Action.Geo.FetchCountiesCompleted,
      Action.Geo.FetchCountiesFailed,
    ].map(actionType => ({ type: actionType, meta })),
  });
}

export function fetchLocalities(area, regionCode, countyId, countryCode) {
  const areaKey = createAreaKey({ area, countyId, regionCode, countryCode });
  const meta = { key: areaKey };

  return generateRequest({
    endpoint: `/assets-v2/api/geo/localities?${areaKey}`,
    types: [
      Action.Geo.FetchLocalities,
      Action.Geo.FetchLocalitiesCompleted,
      Action.Geo.FetchLocalitiesFailed,
    ].map(actionType => ({ type: actionType, meta })),
  });
}

export function fetchLocalitySuggestions(area) {
  const areaKey = createAreaKey({ area });

  return generateRequest({
    endpoint: `/assets-v2/api/geo/suggestions/localities?${areaKey}`,
    types: [
      Action.Geo.FetchSuggestions,
      {
        type: Action.Geo.FetchSuggestionsCompleted,
        meta: { key: areaKey },
      },
      Action.Geo.FetchSuggestionsFailed,
    ],
  });
}

export function fetchMetros(regionCode, countryCode) {
  const areaKey = createAreaKey({ regionCode, countryCode });
  const meta = { key: areaKey };
  return generateRequest({
    endpoint: `/assets-v2/api/geo/regions/${regionCode}/${countryCode}/metros`,
    types: [
      Action.Geo.FetchMetros,
      Action.Geo.FetchMetrosCompleted,
      Action.Geo.FetchMetrosFailed,
    ].map(actionType => ({ type: actionType, meta })),
  });
}

export function fetchRegion(areaName) {
  const region = getRegionByName(areaName);
  return {
    type: Action.Geo.FetchRegionCompleted,
    payload: {
      regionCode: region.abbr,
      countryCode: region.countryCode,
    },
  };
}
